module.exports = __webpack_public_path__ + "img/logo-9.f059ddb9.svg";